export default __webpack_public_path__ + "static/media/aave-logo-white.b1482815.svg";